import { useContext } from 'react';
import { IsLiteContext } from '@/context';

const useDevice = () => {
    const deviceInfo = useContext(IsLiteContext);
    return deviceInfo;
};

export default useDevice;
